import axios from "../axiosPlugin.js";

export const getMovieDetail = id => {
  return axios({
    url: "/api/film/detail/" + id,
    method: "get",
    data: {},
  });
};

export const createMovie = (data, loading = true) => {
  return axios({
    url: "/api/film/create",
    method: "post",
    data: {
      data,
      loading,
    },
  });
};

export const updateMovie = (data, loading = true) => {
  return axios({
    url: "/api/film/update",
    method: "put",
    data: {
      data,
      loading,
    },
  });
};

export const getFilmCompanyList = (
  data,
  loading = true,
  isDefaultAlertTips = true
) => {
  return axios({
    url: "/api/filmCompany/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const deleteMovie = (data, loading = true) => {
  return axios({
    url: "/api/film/delete/" + data.id,
    method: "delete",
    data: {
      data: {},
      loading,
    },
  });
};

export const getMovieGenreListService = () => {
  return axios({
    url: "/api/film/genreList",
    method: "get",
    data: {},
  });
};

export const getMovieGenreListMapService = (data, loading = true) => {
  return axios({
    url: "/api/film/genreListMap",
    method: "get",
    data: {
      data,
      loading,
    },
  });
};

export const getMovieAreaListService = () => {
  return axios({
    url: "/api/film/areaList",
    method: "get",
    data: {},
  });
};

export const getMovieAreaListMapService = (data, loading = true) => {
  return axios({
    url: "/api/film/areaListMap",
    method: "get",
    data: {
      data,
      loading,
    },
  });
};

export const approveMovieService = data => {
  let queryString =
    "accountType=" +
    data.accountType +
    (data.cinemaId ? "&cinemaId=" + data.cinemaId : "&brandId=" + data.brandId);

  return axios({
    url: "/api/film/approve?" + queryString,
    method: "post",
    data: {},
  });
};

/**
 *
 * @param {brandId, cinemaId, status, type} data
 * @returns {
  "data": [
    {
      "actualAmount": 0,
      "boxOfficeAmount": 0,
      "brandId": "string",
      "checkMessages": [
        {
          "checkMsg": "string",
          "deviceType": "CMS"
        }
      ],
      "cinemaId": "string",
      "clientId": "string",
      "createTime": 0,
      "feeCircle": 0,
      "feeCircleType": "percent",
      "glassesAmount": 0,
      "id": "string",
      "mobilize": true,
      "name": "string",
      "parentId": "string",
      "sellAmount": 0,
      "status": "active",
      "ticketingCode": "string",
      "type": "brand",
      "usableVersion1": "string",
      "useNumber": 0
    }
  ],
  "error": "auth_fail",
  "message": "string",
  "success": true
}
 */
export const getMoviTicketListService = (data, showLoading) => {
  if (typeof data === "undefined" || typeof data.type === "undefined") {
    console.warn("[getMoviTicketListService] need mandatory parameters to call!");
    return false;
  }

  return axios({
    url: "/api/movieTicket/list",
    method: "get",
    data: { data, loading: showLoading },
  });
};

/**
 *
 * @param {"movieTicketInfoList": [{
      "actualAmount": 0,
      "boxOfficeAmount": 0,
      "brandId": "string",
      "checkMessages": [
        {
          "checkMsg": "string",
          "deviceType": "CMS"
        }
      ],
      "cinemaId": "string",
      "clientId": "string",
      "createTime": 0,
      "feeCircle": 0,
      "feeCircleType": "percent",
      "glassesAmount": 0,
      "id": "string",
      "mobilize": true,
      "name": "string",
      "parentId": "string",
      "sellAmount": 0,
      "status": "active",
      "ticketingCode": "string",
      "toBeDelete": true,
      "type": "brand",
      "usableVersion1": "string",
      "useNumber": 0
 }]} data
 * @returns {
  "data": true,
  "error": "auth_fail",
  "message": "string",
  "success": true
}
 */
export const submitMoviTicketService = data => {
  if (typeof data === "undefined") {
    console.warn("[submitMoviTicketService] need mandatory parameters to call!");
    return false;
  }

  return axios({
    url: "/api/movieTicket/submit",
    method: "post",
    data: { data: { movieTicketInfoList: data } },
  });
};

export const deleteMovieTicket = (movieTicketId, loading = true) => {
  if (!movieTicketId) {
    console.error("[deleteMovieTicket] please provide a 'movieTicketId'");
  }
  return axios({
    url: "/api/movieTicket/delete/" + movieTicketId,
    method: "delete",
    data: {
      data: {},
      loading,
    },
  });
};

export const updateMovieTicket = data => {
  if (!data) {
    console.error("[updateMovieTicket] please provide a 'movieTicketInfo' as request body");
  } else {
    return axios({
      url: "/api/movieTicket/update",
      method: "put",
      data: { data },
    });
  }
};

export const createMovieTicket = data => {
  if (!data) {
    console.error("[updateMovieTicket] please provide a 'movieTicketInfo' as request body");
  } else {
    return axios({
      url: "/api/movieTicket/create",
      method: "post",
      data: { data }
    });
  }
};


export const getMovieTicket = (movieTicketId, data) => {
  if (!movieTicketId) {
    console.error("[getMovieTicket] please provide a 'movieTicketId'");
  } else {
    return axios({
      url: "/api/movieTicket/detail/" + movieTicketId,
      method: "get",
      data: { data }
    });
  }
};
